import { type LeaderboardItem } from '@app/client/common/structs/competitions/wishlists';
import { compare } from '@app/helpers';

import { type GameItemData } from './types';

function formatTwitterHandle(handle?: LeaderboardItem['twitter_handle']) {
    return handle?.length ? `@${handle}` : undefined;
}

export function getTimestamp(startsAt?: string, endsAt?: string) {
    const nowTimestamp = Date.now();
    const startTimestamp = Date.parse(startsAt ?? '');
    const endTimestamp = Date.parse(endsAt ?? '');

    // TODO: This will need to be re-evaluated at a set interval so that
    // we can switch between `false / true` in real time.
    const checkAgainstNow = (timestamp) => (isNaN(timestamp) ? false : nowTimestamp >= timestamp);
    const started = checkAgainstNow(startTimestamp);
    const ended = checkAgainstNow(endTimestamp);

    return {
        timestamp: startTimestamp,
        started,
        ended,
    };
}

export function entryToGameItemData(props: LeaderboardItem, initialBudget: number): GameItemData {
    const {
        primary_yat,
        twitter_handle,
        rank,
        wishlist_name,
        submission_value,
        current_value,
        profit,
        username,
        primary_yat_heading,
        item_count,
        wishlist_id,
        budget_usd,
        // TODO: The typing for `collections` appears to be
        // incorrect, as it can sometimes be `undefined`.
        collections = [],
    } = props || {};
    const investment = submission_value || 0;
    const currentValue = current_value || 0;
    const percentage = ((profit || 0) / initialBudget) * 100;

    return {
        ...props,
        id: wishlist_id,
        title: wishlist_name || '',
        handle: formatTwitterHandle(twitter_handle),
        rank,
        yat: primary_yat || '',
        username: username || primary_yat_heading || '',
        profitLoss: profit,
        percentage,
        investment,
        budget: budget_usd,
        currentValue,
        // TODO: Tim is going to make this available in the response.
        quantity: item_count,
        // TODO: This needs to be fetched via each `collection` string.
        topPicksSlugs: collections,
        // TODO: Not sure how this is obtained.
        seasonWinner: false,
    };
}

export function sortedEntries(entries: LeaderboardItem[]) {
    return entries.sort((rankA, rankB) => compare(rankA.rank, rankB.rank));
}
